<div [innerHTML]="texto">Texto</div>